import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const ShareIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 14H2V5.00002H6.76L8.76 3.00002H1C0.45 3.00002 0 3.45002 0 4.00002V15C0 15.55 0.45 16 1 16H12C12.55 16 13 15.55 13 15V7.25002L11 9.25002V14ZM15 0H10C9.45 0 9 0.45 9 1C9 1.55 9.45 2 10 2H12.59L7.3 7.29C7.11 7.48 7 7.73 7 8C7 8.55 7.45 9 8 9C8.28 9 8.53 8.89 8.71 8.71L14 3.42V6.01C14 6.56 14.45 7.01 15 7.01C15.55 7.01 16 6.56 16 6.01V1.01C16 0.45 15.55 0 15 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default ShareIcon;
